import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'

const Header = ({ cssColor, active }) => {
  return (
    <div className='checkout-step-payment checkout-step row px-2 border-bottom border-color-ui-3'>
      <div className='col-auto px-1'>
        <div className='row mx-0 align-items-center h-100'>
          <Icon
            className={`${cssColor}`}
            iconName='icon_pay'
          />
        </div>
      </div>
      <div className='col'>
        <div className='row mx-0 align-items-center h-100'>
          {active
            ? <div className='col-auto mr-auto'>
              <h1 className={`active-checkout-step txt-body txt-uppercase ${cssColor}`}>Pagamento</h1>
            </div>
            : <div className='col-auto mr-auto'>
              <span className={`inactive-checkout-step txt-body txt-uppercase h2 ${cssColor}`}>Pagamento</span>
            </div> }
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  cssColor: PropTypes.string.isRequired,
  active: PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Header/Header.js